<div
  class="bg-container"
  [ngStyle]="{ 'background-image': backgroundImage && 'url(&quot;' + backgroundImage + '&quot;)' }"
>
  <div class="container fashion-login">
    <div class="login-container">
      <div class="login-logo" style="background: unset !important;">
        <img class="logo-position" [src]="logoUrl || './assets/logo.png'" />
      </div>
      <lib-language-selection></lib-language-selection>
      <form *ngIf="view === 'login'" [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="mt-3">
        <div class="form-group pb-2">
          <label for="username" translate>USERNAME</label>
          <input
            type="text"
            formControlName="username"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
            [placeholder]="'USERNAME' | translate"
          />
          <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
            <div *ngIf="f.username.errors.required" translate>USERNAME_REQUIRED</div>
          </div>
        </div>
        <div class="form-group">
          <!-- <label for="password" translate>PASSWORD</label>
              <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                [placeholder]="'PASSWORD' | translate"/> -->
          <lib-gung-password-input
            [enablePasswordRequirement]="false"
            [suppressLabel]="true"
            gungTranslate="PASSWORD"
            [placeholder]="'PASSWORD' | translate"
            formControlName="password"
            extraInputClass="custom-login-input {{ submitted && f.password.errors ? ', is-invalid' : '' }}"
            [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
          ></lib-gung-password-input>
          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required" translate>PASSWORD_REQUIRED</div>
          </div>
        </div>
        <div
          *ngIf="error && (error.type === ActionTypes.BadLogin || error.type === ActionTypes.BackendDown)"
          class="alert alert-danger"
        >
          <span *ngIf="error.type === ActionTypes.BadLogin || error.type === ActionTypes.BackendDown" translate
            >LOGIN_FAILED</span
          >
          <!-- <span *ngIf="error.type === ActionTypes.BackendDown" translate>BACKEND_DOWN</span> -->
        </div>
        <div class="form-group d-flex justify-content-center align-items-center login-button-top-margin">
          <button *ngIf="!loading" class="btn btn-primary button-login" translate>LOGIN</button>
          <i *ngIf="loading" class="fa fa-spinner fa-spin fa-lg"></i>
        </div>
        <div class="form-group d-flex justify-content-center align-items-center">
          <a (click)="$event.stopPropagation(); view = 'forgot-password'" class="forgot-password-text" translate
            >FORGOT_PASSWORD</a
          >
          <a
            *ngIf="requestAccountEnabled"
            (click)="$event.stopPropagation(); view = 'request-account'"
            class="forgot-password-text"
            translate
            >REQUEST_ACCOUNT</a
          >

        </div>

      </form>
      <lib-forgot-password *ngIf="view === 'forgot-password'" (returnToLogin)="view = 'login'"></lib-forgot-password>
      <lib-request-account *ngIf="view === 'request-account'" (returnToLogin)="view = 'login'"></lib-request-account>
    </div>
  </div>
</div>
